import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import Dashboard from "@/pages/Dashboard";
import ATSAnalyzer from "@/pages/ATSAnalyzer";
import NHSGenerator from "@/pages/NHSGenerator";
import BandCoaching from "@/pages/BandCoaching";
import CVRewriter from "@/pages/CVRewriter";
import InterviewSimulator from "@/pages/InterviewSimulator";
import PricingPage from "@/pages/PricingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import SettingsPage from "@/pages/SettingsPage";
import LegalPage from "@/pages/LegalPage";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-[#003087] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/privacy-policy" element={<LegalPage defaultTab="privacy" />} />
      <Route path="/terms-of-use" element={<LegalPage defaultTab="terms" />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/ats" element={<ProtectedRoute><ATSAnalyzer /></ProtectedRoute>} />
      <Route path="/nhs-generator" element={<ProtectedRoute><NHSGenerator /></ProtectedRoute>} />
      <Route path="/band-coaching" element={<ProtectedRoute><BandCoaching /></ProtectedRoute>} />
      <Route path="/cv-rewriter" element={<ProtectedRoute><CVRewriter /></ProtectedRoute>} />
      <Route path="/interview" element={<ProtectedRoute><InterviewSimulator /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
